export enum DeviceBreakPoint {
    Desktop = 1200,
    SmallerDesktop = 992,
    Tablet = 768,
    SmallerTablet = 576,
    Mobile = 320,
}

export enum Brand {
    VM = 'vm',
    VMO2 = 'vmo2',
}

export enum Journey {
    UpperFunnel = 'upperfunnel'
}

export enum IntentType {
    VOLT = 'volt'
}
